/**
 * Mobile Users API Service
 * Appels API pour la consultation admin des utilisateurs mobiles (élèves/parents).
 */

import type {
  ListMobileUsersParams,
  MobileUsersListResponse,
} from '../types/mobileUser';
import { ADMIN_URLS } from '../config/adminApi';
import { createApiClient } from '../lib/http';

const mobileUsersApi = createApiClient();

// ============================================================================
// Mobile Users API
// ============================================================================

/** Liste les utilisateurs mobiles avec filtres optionnels. */
export const listMobileUsers = async (
  params?: ListMobileUsersParams
): Promise<MobileUsersListResponse> => {
  const response = await mobileUsersApi.get<MobileUsersListResponse>(`${ADMIN_URLS.mobileUsers}`, {
    params,
  });
  return response.data;
};

export interface ResetPasswordResponse {
  success: boolean;
  /** Mot de passe appliqué (à communiquer à l'utilisateur). */
  password?: string;
  error?: string;
  message?: string;
}

/**
 * Définit un nouveau mot de passe pour un utilisateur mobile (action admin).
 * Si `newPassword` est vide, le backend en génère un et le renvoie.
 */
export const resetMobileUserPassword = async (
  uid: string,
  newPassword?: string
): Promise<ResetPasswordResponse> => {
  const response = await mobileUsersApi.post<ResetPasswordResponse>(
    `${ADMIN_URLS.mobileUsers}/${uid}/reset-password`,
    { newPassword }
  );
  return response.data;
};
